import Checkbox from '@material-ui/core/Checkbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { shoppingCustomerDeliveryPlacesAllSelector } from '../../../api/shopping';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

export type CustomerProfilePageDeliveryPlaceSelectorProps = {
  onChange: any;
  subsidiaryId: string;
  value: Array<string>;
};

export type CustomerProfilePageDeliveryPlaceSelectorClassKey =
  | 'root'
  | 'label'
  | 'list'
  | 'field'
  | 'mainDeliveryPlace'
  | 'deliveryPlace';

const useStyles = makeStyles((theme) =>
  createStyles<CustomerProfilePageDeliveryPlaceSelectorClassKey, {}>({
    root: {},
    list: {
      maxHeight: '400px',
      overflow: 'scroll',
      overflowX: 'hidden',
    },
    label: {
      marginTop: theme.spacing(2),
      fontWeight: 'bold',
    },
    field: {
      borderRadius: '25px',
      marginBottom: theme.spacing(0.5),
    },
    mainDeliveryPlace: {
      backgroundColor: '#00B4D8',
    },
    deliveryPlace: {
      backgroundColor: '#ADE8F4',
    },
  }),
);

const CustomerProfilePageDeliveryPlaceSelector: React.FC<CustomerProfilePageDeliveryPlaceSelectorProps> = ({
  // userId,
  // customerId,
  onChange,
  subsidiaryId,
  value,
}) => {
  const classes = useStyles();
  const t = useTranslateWithFallback();
  const places: Array<any> = useRecoilValue(shoppingCustomerDeliveryPlacesAllSelector) || [];

  return (
    <div className={classes.root}>
      <div className={classes.label}>{t('customerProfilePage/deliveryPlaces/label')}</div>
      <List className={classes.list}>
        {places?.map((item, index: number) => {
          const address =
            (item.postaddresses || []).find((address: Record<string, any>) => address.type === 'HQ')?.place.full ||
            null;

          const isSelecteAsMainContact = subsidiaryId === item.id;
          const isSelectedAsDeliveryPlace = value.find((x) => x === item.id);
          return (
            <ListItem
              key={index}
              className={clsx(classes.field, {
                [classes.mainDeliveryPlace]: isSelecteAsMainContact,
                [classes.deliveryPlace]: !isSelecteAsMainContact && isSelectedAsDeliveryPlace,
              })}
              title={isSelecteAsMainContact ? t('customerProfilePage/changeData/mainContact') : undefined}
            >
              <Checkbox
                checked={isSelecteAsMainContact || !!isSelectedAsDeliveryPlace}
                disabled={isSelecteAsMainContact}
                onChange={(e, b) => onChange(b ? [...value, item.id] : value.filter((id) => id !== item.id))}
              />
              <Typography>{`${item.officeName || item.name}${address != null ? ` - ${address}` : ''}`}</Typography>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
};

export default CustomerProfilePageDeliveryPlaceSelector;
